import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form } from 'antd';
import { normalizeTranslations } from '../../components/LocalizedContentTabs';
import { PetSkinCategoryFormFields, PET_SKIN_CATEGORY_LANG_FIELDS } from './fields';

export const PetSkinCategoryEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({
    resource: 'pet-skin-categories',
  });
  const existing = queryResult?.data?.data as { translations?: any } | undefined;

  return (
    <Edit resource="pet-skin-categories" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          // The slug is immutable server-side; sending it back would be ignored.
          const { slug: _slug, ...rest } = values;
          return formProps.onFinish?.({
            ...rest,
            translations: normalizeTranslations(
              values.translations,
              PET_SKIN_CATEGORY_LANG_FIELDS,
              existing?.translations,
            ),
          });
        }}
      >
        <PetSkinCategoryFormFields slugEditable={false} />
      </Form>
    </Edit>
  );
};
